import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap, tap } from 'rxjs/operators';
import { ActionTypes } from '@appStore/account/actions';
import * as actions from '@appStore/account/actions';
import { UserMarketingSettingsService } from '@appStore/account/services/user-marketing-settings.service';
import { Router } from '@angular/router';

@Injectable()
export class UserMarketingSettingsEffects {
  constructor(
    private router: Router,
    private userMarketingSettingsService: UserMarketingSettingsService,
    private actions$: Actions
  ) {}

  loadUserMarketingSettings$ = createEffect(() => {
    return   this.actions$.pipe(
      ofType(ActionTypes.UserMarketingSettingsLoadData),
      exhaustMap(action => {
        return this.userMarketingSettingsService.GetMyMarketingSettings().pipe(
          map(marketingSettings => new actions.UserMarketingSettingsLoadSuccess(marketingSettings)),
          catchError(error => of(new actions.UserMarketingSettingsLoadFail(error)))
        );
      })
    );
  });

  updateUserMarketingSettings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.UserMarketingSettingsUpdate),
      exhaustMap((action: actions.UserMarketingSettingsUpdate) => {
        return this.userMarketingSettingsService.UpdateMyMarketingSettings(action.payload).pipe(
          map(updatedSettings => new actions.UserMarketingSettingsUpdateSuccess(updatedSettings)),
          catchError(error => of(new actions.UserMarketingSettingsUpdateFail(error)))
        );
      })
    );
  });
  
}
